/**
 * encode cardId
 */
export const encode = () => {
  return {
    0: 'e',
    1: 'f',
    2: '0',
    3: '1',
    4: '2',
    5: '3',
    6: '4',
    7: '5',
    8: '6',
    9: '7',
    a: '8',
    b: '9',
    c: 'a',
    d: 'b',
    e: 'c',
    f: 'd',
  };
};

/**
 * decode cardId
 */
export const decode = () => {
  return {
    e: '0',
    f: '1',
    0: '2',
    1: '3',
    2: '4',
    3: '5',
    4: '6',
    5: '7',
    6: '8',
    7: '9',
    8: 'a',
    9: 'b',
    a: 'c',
    b: 'd',
    c: 'e',
    d: 'f',
  };
};
